import type { ButtonHTMLAttributes, CSSProperties } from 'react';
import { cn } from '../cn';

export interface StackedActionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  /** Mono state line under the label (ON / OFF / 01:42:18). */
  state: string;
  on?: boolean;
  onBg?: string;
  onColor?: string;
}

/** Mobile 56 px two-line action (Captions / Record / Listen / Blank). */
export function StackedActionButton({ label, state, on, onBg, onColor, className, style, ...rest }: StackedActionButtonProps) {
  const onStyle: CSSProperties | undefined = on ? { background: onBg ?? 'var(--fg)', color: onColor ?? 'var(--bg)' } : undefined;
  return (
    <button
      type="button"
      aria-pressed={!!on}
      className={cn(
        'flex h-14 flex-col items-center justify-center gap-[5px] rounded-xl p-0 text-md font-medium',
        on ? 'border border-transparent' : 'border border-border bg-btn text-fg',
        className,
      )}
      style={{ ...onStyle, ...style }}
      {...rest}
    >
      <span>{label}</span>
      <span className="meta opacity-70">{state}</span>
    </button>
  );
}
